import { FieldReviewTable } from '../fieldReviewTable';

export interface ClosingProtectionLetterReviewTableProps {
  data: Record<string, any>;
}

export const ClosingProtectionLetterReviewTable = ({
  data,
}: ClosingProtectionLetterReviewTableProps) => {
  return <FieldReviewTable items={data?.items} />;
};
